import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const itemVariants = tv({
  variants: {
    layout: {
      vertical: "mb-2",
      horizontal: "",
      inline: "inline-block mr-2"
    }
  },
  defaultVariants: {
    layout: "vertical"
  }
}), componentVariants = tv({
  variants: {
    layout: {
      vertical: "",
      horizontal: "",
      inline: ""
    }
  },
  compoundVariants: [
    { layout: ["horizontal", "inline"], class: "flex mb-2" }
  ],
  defaultVariants: {
    layout: "vertical"
  }
}), formLabelVariants = tv({
  variants: {
    layout: {
      vertical: "",
      horizontal: "",
      inline: ""
    }
  },
  compoundVariants: [
    { layout: ["horizontal", "inline"], class: "mr-2 max-h-9" }
  ],
  defaultVariants: {
    layout: "vertical"
  }
});
export {
  componentVariants,
  formLabelVariants,
  itemVariants
};
//# sourceMappingURL=index.js.map
